import { pick } from 'lodash';

export const pickOrDefault = (obj, fieldsToPick, defaultValues) =>
  obj ? pick(obj, fieldsToPick) : defaultValues;
